import { createContext } from "react"
import { emptyVehicle, IVehicle } from "../../../../types/vehicle.type"

type InitialStateType = {
  vehicle: IVehicle
}

export const initialState: InitialStateType = {
  vehicle: emptyVehicle()
}
export const VehicleDashboardContext = createContext(initialState)
